export default __webpack_public_path__ + "static/media/exchangelogo.d225ce04.svg";